/* lua.js generated code 0.3.1 */

require("clover/gamePlay/CreateGameSceneLogic")
let GoldStartLevelLogic = xClass("GoldStartLevelLogic")

GoldStartLevelLogic.checkCanStart = function () {
    let info = GoldMatchActivityManager.getInstance().getInfo()
    let local = Localhost.time()
    let activityEnd = local >= info.end
    if (activityEnd) {
        return [null, ZooErrorCode.TIME_MODE_ACTIVITY_END]
    }
    let hasTimes = info.leftTimes > 0
    if (!hasTimes) {
        return [null, ZooErrorCode.TIME_MODE_TIME_NOT_ENOUGT]
    }
    return [true]
}
GoldStartLevelLogic.create = function (levelId, force = false) {
    let self = this
    if (force) {
        return [GoldStartLevelLogic.new(levelId)]
    }
    let [success, errCode] = self.checkCanStart(levelId)
    if (!success) {
        return [null, errCode]
    }
    return [GoldStartLevelLogic.new(levelId)]
}
GoldStartLevelLogic.prototype.ctor = function (levelId) {
    let self = this
    self.initProps = table()
    self.levelId = levelId
    self.initProps = table()
    UserLevel.getInstance().addLevelTypeEnum(GameLevelType.kGold, GoldUserLevelType)
}
GoldStartLevelLogic.prototype.initLevelLogics = function () {
    require.ensure([], () => {
        require("clover/scene/GameScene")
        require("clover/scene/GameSceneUI")
        FailLevelLogicClassTypeRef[GameLevelType.kGold] = require("activity/GoldMatchActivity/levelLogic/GoldFailLevelLogic")
        PassLevelLogicClassTypeRef[GameLevelType.kGold] = require("activity/GoldMatchActivity/levelLogic/GoldPassLevelLogic")
        QuitLevelLogicClassTypeRef[GameLevelType.kGold] = require("activity/GoldMatchActivity/levelLogic/GoldQuitLevelLogic")
        GameReviveLogicClassTypeRef[GameLevelType.kGold] = require("activity/GoldMatchActivity/levelLogic/GoldReviveLogic")
    }, null, 'game')
}
GoldStartLevelLogic.prototype.levelInfo = function () {
    let self = this
    let ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
    let levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    ret.levelType = levelType
    ret.levelId = self.levelId
    return ret
}
GoldStartLevelLogic.prototype.start = function (onSuccess, onFail) {
    let self = this
    self.successCallback = onSuccess
    self.failCallback = onFail
    self.startLevel()
}
GoldStartLevelLogic.prototype.startReplay = function (replay, id, score) {
    let self = this
    let instance = CreateGameSceneLogic.create(self.levelId, self.initProps)
    instance.startReplayGamePlayScene(replay, id, score, () => {
        self.successCallback && self.successCallback()
        self.initLevelLogics()
    })
}
GoldStartLevelLogic.prototype.startLevel = function () {
    let self = this
    let context = this
    function success() {
        let instance = CreateGameSceneLogic.create(context.levelId, context.initProps)
        function fail(event = {}) {
            Toast.make(curryQuickGetErrorText(event.data), 1, () => {
                let sceneName = cc.director._runningScene.name || cc.director._runningScene._name
                if (sceneName !== "HomeScene") {
                    cc.Director.getInstance().popScene()
                }
                self.failCallback && self.failCallback()
            })
        }
        instance.startGamePlayScene(function (fileList) {
            function success(event) {
                // 成功之后扣除次数
                GoldMatchActivityManager.getInstance().onStartLevel(event.data)
                self.successCallback && self.successCallback()
                context.initLevelLogics()
                instance.createGamePlayScene(fileList)
            }
            let retrytime = 2
            function onfail(event) {

                // 如果是后端直接返回错误重试
                if (event && event.data > 0) {
                    retrytime = 0
                }
                if (--retrytime > 0) {
                    setTimeout(() => {
                        startLevel()
                    }, 20);
                } else {
                    fail(event)
                }
            }
            function startLevel() {
                let http = GoldMatchStartLevelHttp.new()
                http.addEventListener(Events.kComplete, success)
                http.addEventListener(Events.kError, onfail)
                http.load(self.levelId)
            }
            startLevel()
        }, fail)
    }
    UserLevel.getInstance().startLevel(self.levelId, self.initProps, success, null, null, false)
}
module.exports = GoldStartLevelLogic
